module.exports = __webpack_public_path__ + "img/it_1.392c2951.jpg";